const getTableStyles = () => {
  return `.env-config-id{
              width: 2%;
          }
          .env-config-env-type{
              width: 3%;
          }
          .env-config-category{
              width: 4%;
          }
          .env-config-key{
              width: 7%;
          }
          .env-config-value{
              width: 15%;
          }
          .env-config-status{
              width: 2%;
          }
          .env-config-added-on{
              width: 8%;
          }
          .env-config-updated-on{
              width: 7%;
          }
          .env-config-action{
              width: 4%;
          }
          `;
};

const getSortingClass = (sortingColumns, column) => {
  return sortingColumns[column] === 1
    ? "_asc"
    : sortingColumns[column] === -1
    ? "_desc"
    : "";
};

export { getTableStyles, getSortingClass };
